import bookFormReducer, * as fromBookForm from './BookForm';
import spreadsReducer, * as fromSpreads from './Spreads';
import applicationReducer, * as fromApplication from './Application';
import userReducer, * as fromUser from './User';
import uiReducer, * as fromUI from './UI';

export default {
  bookForm: bookFormReducer,
  spreads: spreadsReducer,
  application: applicationReducer,
  user: userReducer,
  ui: uiReducer,
};

// Book form state accessors

export const getCurrentStage = state =>
  fromBookForm.getCurrentStage(state.bookForm);
export const getBookInputs = state =>
  fromBookForm.getBookInputs(state.bookForm);
export const hasUnsavedChanges = state =>
  fromBookForm.hasUnsavedChanges(state.bookForm);
export const getCompletedFields = state =>
  fromBookForm.getCompletedFields(state.bookForm);
export const getFieldInEdit = state =>
  fromBookForm.getFieldInEdit(state.bookForm);
export const isValid = state => fromBookForm.isValid(state.bookForm);
export const getFieldsInError = state =>
  fromBookForm.getFieldsInError(state.bookForm);

// Spreads state accessors

export const getRenderByKey = (state, key) =>
  fromSpreads.getRenderByKey(state.spreads, key);
export const getRenderFetchingByKey = (state, key) =>
  fromSpreads.getRenderFetchingByKey(state.spreads, key);
export const getRenderErrorByKey = (state, key) =>
  fromSpreads.getRenderErrorByKey(state.spreads, key);

// Router state accessors

export const getCurrentRouteType = state => state.location.type;

// Application state accessors

export const getSessionId = state =>
  fromApplication.getSessionId(state.application);
export const getInitialisationStatus = state =>
  fromApplication.getInitialisationStatus(state.application);

// User state accessors

export const getRequestingActivityPackStatus = state =>
  fromUser.getRequestingActivityPackStatus(state.user);
export const getRequestActivityPackError = state =>
  fromUser.getRequestActivityPackError(state.user);

// UI state accessors

export const getActiveHook = state => fromUI.getActiveHook(state.ui);

// *** GENERATORS

export const createInitialState = ({ session_id }) => {
  return {
    application: fromApplication.createInitialState(session_id),
  };
};
